import {useQuery, useQueryClient} from 'react-query'
import {Audio_VisualToolsEditModalForm} from './Audio_VisualToolsEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'

const Audio_VisualToolsEditModalFormWrapper = () => {
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  // const {
  //   isLoading,
  //   data: audio_VisualTools,
  //   error,
  // } = useQuery(
  //   `${QUERIES.PARAMETER_LIST}-parameter-${itemIdForUpdate}`,
  //   () => {
  //     return getParameterById(itemIdForUpdate)
  //   },
  //   {
  //     cacheTime: 0,
  //     enabled: enabledQuery,
  //     onError: (err) => {
  //       setItemIdForUpdate(undefined)
  //       console.error(err)
  //     },
  //   }
  // )


  if (!itemIdForUpdate) {
    return <Audio_VisualToolsEditModalForm  audio_VisualTools = {{ id: undefined}} />
  }

  return null
}

export {Audio_VisualToolsEditModalFormWrapper}
